import styled from 'styled-components'
import { truncateStyles } from 'components/common/styles'

export const ButtonLabel = styled.div`
  max-width: 150px;

  ${truncateStyles};
`
